import axios from 'axios'

const addCodesToPackage = async (packageId, formData) => {
  try {
    const response = await axios.post(
      `${process.env.REACT_APP_API_BASE_URL}systemUsers/addCodesToPackage/${packageId}`,
      formData,
      {
        withCredentials: true,
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      }
    )
    return response.data
  } catch (error) {
    throw error
  }
}

export default addCodesToPackage
